// Copyright (c) 2020 embyt GmbH. All rights reserved.
// Author: Roman Morawek

import * as React from "react";
import { connect } from "react-redux";
import { WrappedComponentProps, injectIntl } from "react-intl";

import { DataState, RootPath } from "types";
import { IState } from "states/states";
import { AppState, UserState } from "states/schedulerstates";

import AppStateView from "view/comp/AppState";
import UserSignUp from "view/comp/UserSignUp";

declare const IS_CLOUD: boolean;

interface ISignUpProps {
  isRfidLogin: boolean;
  appState: AppState;
  loginDataState: DataState;
  parameterDataState: DataState;
  wantsSignUp: boolean;
  userEmail: string | undefined;
}

const mapStateToProps = (state: IState) => {
  const props: ISignUpProps = {
    isRfidLogin: state.router.rootPath === RootPath.RFID,
    appState: state.scheduler.appState,
    loginDataState: state.scheduler.loginDataState,
    parameterDataState: state.scheduler.parameterDataState,
    wantsSignUp: [
      UserState.SINGING_UP,
      UserState.SINGING_UP_CONFIRM,
      UserState.FORGOT_PASSWORD,
      UserState.PASSWORD_CONFIRM,
      UserState.PASSWORD_CHANGED,
    ].includes(state.scheduler.userState),
    userEmail: state.gui.login.email,
  };
  return props;
};

class SignUpComponent extends React.Component<ISignUpProps & WrappedComponentProps> {
  public render() {
    return (
      <div id="login">
        <div id="login_inner">
          <div id="login_right">
            <div>{this.props.wantsSignUp && IS_CLOUD && <UserSignUp />}</div>
            <AppStateView />
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(connect(mapStateToProps)(SignUpComponent));
